import React from 'react';
import { DropdownButton, MenuItem } from 'react-bootstrap';
import cssmodules from 'react-css-modules';
import { injectIntl } from 'react-intl';
import { Link } from 'react-router';
import Pager from '../Shared/Pager';
import TableFilterHeader from '../Shared/TableFilterHeader';
import styles from './userstable.cssmodule.scss';

class UsersTable extends React.Component {

  constructor(props) {
    super(props);
    this.state = {
      filterEnabled: false,
      filter: {
        UserId: '',
        Account: '',
        SAPNumber: '',
        DisplayName: '',
        Email: '',
        CipId: '',
        IsAdmin: 0,
        IsActive: 0
      }
    };
  }

  toggleFilter(event) {
    this.setState({
      filterEnabled: !this.state.filterEnabled
    });
  }

  handleFilterChange(propertyName, event) {
    let filter;
    if (typeof event === 'object') {
      filter = {...this.state.filter, [propertyName]: event.target.value};
    } else {
      filter = {...this.state.filter, [propertyName]: event};
    }
    // fire filter changed
    const { filterChanged } = this.props;
    if (filterChanged) {
      filterChanged(filter);
    }
    this.setState({
      filter
    });
  }

  getTextForAdminFilter(filterValue) {
    if (filterValue == 1) {
      return 'Admin';
    } else if (filterValue == 2) {
      return 'Not Admin';
    }
    return 'All';
  }

  getTextForActiveFilter(filterValue) {
    if (filterValue == 1) {
      return 'Active';
    } else if (filterValue == 2) {
      return 'Not Active';
    }
    return 'All';
  }

  render() {
    const {intl} = this.props;
    const t = (message, data = {}) => {
      if (!message) return '';
      return intl.formatMessage({id: message}, data);
    };

    const { userPage } = this.props;
    const { loadNextPage } = this.props;
    const { loadPrevPage } = this.props;
    // eslint-disable-next-line no-unused-vars
    const { IsAdmin } = this.props;

    return (
      <div className="brand-panel panel panel-default filterable" styleName="userstable-component">
        <div className="panel-heading">
          <h3 className="panel-title">{t('FOCUS Users')}
            {
                     userPage.Loading && (<span className="fa fa-refresh fa-spin" style={{marginLeft: '10px'}} />)
                   }
          </h3>
          <div className="pull-right">

            <button className="btn btn-default btn-xs btn-filter" onClick={this.toggleFilter.bind(this)}><span className="glyphicon glyphicon-filter" /> {t('Filter')}</button>
          </div>
        </div>
        <div className="panel-body">
          <Pager pageIndex={userPage.PageIndex} totalPageCount={userPage.TotalPageCount} loading={userPage.Loading} nextClick={loadNextPage} prevClick={loadPrevPage}/>

          {
            false &&
              <div className="btn-group pull-right" role="group" style={{paddingBottom: '10px'}}>
                <Link type="button" className="btn btn-default btn-brand" to="/user">
                  <span className="glyphicon glyphicon-plus" />
                  {t('Add')}</Link>
              </div>
          }

          <table className="table table-condensed table-striped table-bordered" styleName="table-fixed" >
            <thead>
              <tr>
                <TableFilterHeader filterEnabled={this.state.filterEnabled} label={t('Id')} style={{width: '60px'}}>
                  <input value={this.state.filter.Id} onChange={this.handleFilterChange.bind(this, 'UserId')} type="text" className="form-control input-sm" placeholder={t('Id')} />
                </TableFilterHeader>
                <TableFilterHeader filterEnabled={this.state.filterEnabled} label={t('Account')}>
                  <input value={this.state.filter.Account} onChange={this.handleFilterChange.bind(this, 'Account')} type="text" className="form-control input-sm" placeholder={t('Account')}/>
                </TableFilterHeader>
                <th>{this.state.filterEnabled ?
                  <p className="form-control-static">{t('Domain')}</p>
                    :
                  <span>{t('Domain')}</span>
                  }
                </th>
                <TableFilterHeader filterEnabled={this.state.filterEnabled} label={t('Display Name')}>
                  <input value={this.state.filter.DisplayName} onChange={this.handleFilterChange.bind(this, 'DisplayName')} type="text" className="form-control input-sm" placeholder={t('Display Name')}/>
                </TableFilterHeader>
                <TableFilterHeader filterEnabled={this.state.filterEnabled} label={t('Email')}>
                  <input value={this.state.filter.Email} onChange={this.handleFilterChange.bind(this, 'Email')} type="text" className="form-control input-sm" placeholder={t('Email')}/>
                </TableFilterHeader>
                <TableFilterHeader filterEnabled={this.state.filterEnabled} label={t('CIP Id')} style={{width: '60px'}}>
                  <input value={this.state.filter.CipId} onChange={this.handleFilterChange.bind(this, 'CipId')} type="text" className="form-control input-sm" placeholder={t('CIP Id')} />
                </TableFilterHeader>
                <TableFilterHeader filterEnabled={this.state.filterEnabled} label={t('CIP Group')}>
                  <p className="form-control-static"> {t('CIP Group')}</p>
                </TableFilterHeader>
                <TableFilterHeader filterEnabled={this.state.filterEnabled} label={t('Admin')} style={{width: '70px'}}>
                  <DropdownButton value={this.state.filter.IsAdmin} onSelect={this.handleFilterChange.bind(this, 'IsAdmin')} title={t(this.getTextForAdminFilter(this.state.filter.IsAdmin))} id="dd-filter-admin" className="btn-brand btn btn-default btn-sm">
                    <MenuItem eventKey="0">{t('All')}</MenuItem>
                    <MenuItem eventKey="1">{t('Admin')}</MenuItem>
                    <MenuItem eventKey="2">{t('Not admin')}</MenuItem>
                  </DropdownButton>
                </TableFilterHeader>
                <TableFilterHeader filterEnabled={this.state.filterEnabled} label={t('Active')} style={{width: '75px'}}>
                  <DropdownButton value={this.state.filter.IsActive} onSelect={this.handleFilterChange.bind(this, 'IsActive')} title={t(this.getTextForActiveFilter(this.state.filter.IsActive))} id="dd-filter-active" className="btn-brand btn btn-default btn-sm">
                    <MenuItem eventKey="0">{t('All')}</MenuItem>
                    <MenuItem eventKey="1">{t('Active')}</MenuItem>
                    <MenuItem eventKey="2">{t('Not Active')}</MenuItem>
                  </DropdownButton>
                </TableFilterHeader>

              </tr>
            </thead>
            <tbody>
              {
                (userPage.Data).map((u, idx) =>
                  (<tr key={u.Id}>
                    <td>
                      <Link to={`/user/${u.Id}`}>{u.Id}</Link>
                    </td>
                    <td className="word-break">{u.Account}</td>
                    <td>{u.Domain}</td>
                    <td className="word-break">{u.DisplayName}</td>
                    <td className="word-break" >{u.Email}</td>
                    <td>{u.CipGroup ? <Link to={`/cipGroup/${u.CipGroup.Id}`}>{u.CipGroup.Id}</Link> : ''}</td>
                    <td>{u.CipGroup ? u.CipGroup.Title : ''}</td>
                    <td><i className={u.IsAdmin ? 'glyphicon glyphicon-ok' : 'glyphicon'}/></td>
                    <td><i className={u.IsActive ? ' glyphicon glyphicon-ok ' : 'glyphicon'}/></td>
                  </tr>)
                )
              }
            </tbody>
          </table>

        </div>
      </div>
    );
  }
}

UsersTable.displayName = 'UsersTable';
UsersTable.propTypes = {};
UsersTable.defaultProps = {
  userPage: {
    Data: [],
    Loading: true,
    TotalPageCount: 1,
    PageIndex: 1
  }
};

export default injectIntl(cssmodules(UsersTable, styles));



// WEBPACK FOOTER //
// ./components/Users/UsersTable.js